export default __webpack_public_path__ + "static/media/infosys1.665cfdd3.PNG";